import React, { useState, useEffect } from "react";
import { Pagination, Tooltip } from 'carbon-components-react';
import { SimpleBarChart } from "@carbon/charts-react";
import moment from "moment";
import { v1 } from "uuid";

import callPostApi from "requests/PostRequests";
import * as Constants from "../../../requests/URLConstants";
import DashboardTable from "../DashboardTable";
import * as DashboardUtils from "../DashboardUtils.js";
import TableToolbarDownload from "../../../common/TableToolbarDownload";
import * as BOTTable from "./tableHeaders";
import DashboardLineChart from "../DashboardLineChart";
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'
import { ReactComponent as SquareFill } from 'assets/image/square-fill.svg';
import TableComponent from './TableComponent';
import './BotPerformance.scss';

const BotPerformance = (props) => {
    const [BotPerformanceLoading, setBotPerformanceLoading] = useState(true);
    const [BotPerformanceTableData, setBotPerformanceTableData] = useState([]);
    const [BotPerformanceGraphData, setBotPerformanceGraphData] = useState([]);
    const [BotPerformanceGraphLoading, setBotPerformanceGraphLoading] = useState(true);
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(3);
    const [barChartLoading, setBarChartLoading] = useState(true);
    const [firstTimeBarData, setFirstTimeBarData] = useState([]);
    const [firstTimeDownloadRows, setFirstTimeDownloadRows] = useState([]);
    const [firstTimeRunTableData, setFirstTimeRunTableData] = useState([]);
    const [firstTimeTableLoading, setFirstTimeTableLoading] = useState(true);

    let count = {
        range1: 0,
        range2: 0,
        range3: 0,
        range4: 0,
        range5: 0,
        range6: 0,
        range7: 0,
    }
    const [botsCount, setBotsCount] = useState(count);

    useEffect(() => {
        getBotPerformance(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotPerformanceGraph(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getFirstTimeRun(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    useEffect(() => {
        getPaginatedRows(firstRowIndex, currentPageSize);
    }, [BotPerformanceTableData]);

    const getPaginatedRows = (param, pageSize) => {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = BotPerformanceTableData.slice(startingIndex, startingIndex + pageSize);
        setPaginatedRows(slicedRows);
    };

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {

        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                filters: {
                    time: {
                        startDateTime: timeFilterSelections.startDateTime,
                        endDateTime: timeFilterSelections.endDateTime,
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "resource": dashboardFilterSelectionsAutomation.resource,
                    "process_name": dashboardFilterSelectionsAutomation.process_name,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id
                },
                interval: {
                    calender_Interval: calenderInterval,
                    time_zone: timeZone,
                },
                workspace: workspace,
            };
        }
        return bodyJSON;
    };

    const prepareBotPerformanceTableData = (response) => {
        if (response) {
            let tableData = [];
            let tableObj = {};
            let dataObj = {};
            let tableArray = [];
            let result = [];
            let buckets = response.aggregations.franchise.buckets;
            for (let i = 0; i < buckets.length; i++) {
                for (let j = 0; j < buckets[i].deployment.buckets.length; j++) {
                    tableObj = {};
                    dataObj = {};
                    tableObj.id = ((i + 1).toString());
                    tableObj.deployment = buckets[i].deployment.buckets[j].key;
                    dataObj.id = ((i + 1).toString());
                    dataObj.franchise = buckets[i].key;
                    dataObj.termination = buckets[i].deployment.buckets[j].termination.value;
                    dataObj.process = buckets[i].deployment.buckets[j].process.value;
                    dataObj.executions = buckets[i].deployment.buckets[j].doc_count;
                    dataObj.completed = dataObj.executions - dataObj.termination;
                    let terminationpercent = (dataObj.termination / dataObj.executions) * 100;
                    dataObj.terminationrate = terminationpercent ? terminationpercent.toFixed(2) + '%' : 0;
                    tableArray.push({
                        id: tableObj.id,
                        tablename: tableObj.deployment,
                        data: [dataObj]
                    });
                }
            }
            let item;
            for (item of tableArray) {
                const existingEntry = result.find(o => o.tablename === item.tablename);
                if (existingEntry) {
                    existingEntry.data = existingEntry.data.concat(item.data);
                } else {
                    result.push(item);
                }
            }
            tableData = tableData.concat(result);
            return { tableData };
        }
    };

    const getBotPerformance = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotPerformanceLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTPERFORMANCESUMMARY, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareBotPerformanceTableData(resp);
                    setBotPerformanceTableData(formattedData.tableData);
                    setBotPerformanceLoading(false);
                })
                .catch((error) => {
                    setBotPerformanceLoading(false);
                });
        }
    };

    const prepareBotPerformanceGraph = (response) => {
        let data = [];
        let obj = {};
        if (response) {
            let buckets = response.aggregations.interval.buckets;
            for (let i = 0; i < buckets.length; i++) {
                for (let j = 0; j < buckets[i].franchise.buckets.length; j++) {
                    obj = {
                        group: buckets[i].franchise.buckets[j].key,
                        date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                        value: (buckets[i].franchise.buckets[j].percentage.value).toFixed(2)
                    }
                    data.push(obj);
                }
            }
        }
        return data;
    };

    const getBotPerformanceGraph = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotPerformanceGraphLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETROBOTTERMINATIONTREND, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareBotPerformanceGraph(resp);
                    setBotPerformanceGraphData(formattedData);
                    setBotPerformanceGraphLoading(false);
                })
                .catch((error) => {
                    setBotPerformanceGraphLoading(false);
                });
        }
    };

    const getFirstTimeRun = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotPerformanceGraphLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETFIRSTTIMERUN, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    console.log(resp);
                    prepareFirstTimeRunTable(resp);
                    prepareFirstTimeRunBarData(botsCount);
                    setFirstTimeTableLoading(false);
                    setBarChartLoading(false);
                    // setBotPerformanceGraphData(formattedData);
                    // setBotPerformanceGraphLoading(false);
                })
                .catch((error) => {
                    setBotPerformanceGraphLoading(false);
                });
        }
    };

    function prepareTableBarData(data) {
        let dataArr = [], downloadArr = [];
        data.map((items) => {
            console.log(items);
            let fillColor = '';
            let successOf1stRun = isNaN(items.successOf1stRun) || items.successOf1stRun === '0.00' ? 0 : items.successOf1stRun === '100.00' ? 100 : items.successOf1stRun;

            if ((successOf1stRun <= 25.00 || successOf1stRun <= 25) && successOf1stRun > 0) {
                fillColor = '#FA6400';
                count.range1 = botsCount.range1 + 1;
            }
            else if ((successOf1stRun <= 50.00 || successOf1stRun <= 50) && successOf1stRun >= 25.01) {
                fillColor = '#F7B500';
                count.range2 = botsCount.range2 + 1;
            }
            else if ((successOf1stRun <= 80.00 || successOf1stRun <= 80) && successOf1stRun >= 50.01) {
                fillColor = '#0091FF';
                count.range3 = botsCount.range3 + 1;
            }
            else if ((successOf1stRun <= 95.00 || successOf1stRun <= 95) && successOf1stRun >= 80.1) {
                fillColor = '#32C5FF';
                count.range4 = botsCount.range4 + 1;
            }
            else if (successOf1stRun <= 99.99 && successOf1stRun >= 95.01) {
                fillColor = '#44D7B6';
                count.range5 = botsCount.range5 + 1;
            }
            else if (successOf1stRun === 100) {
                fillColor = '#6DD400';
                count.range6 = botsCount.range6 + 1;
            }
            else if (successOf1stRun === 0) {
                fillColor = '#E02020';
                count.range7 = botsCount.range7 + 1;
            }
            let dataObj = {
                id: v1(),
                botId: <div><SquareFill fill={fillColor} />{items.botId} </div>,
                totalRuns: items.totalRuns,
                //totalSuccess: items.totalSuccess,
                successOnFirstRun: items.successOnFirstRun,
                successOf1stRun: isNaN(items.successOf1stRun) || items.successOf1stRun === '0.00' ? 0 : items.successOf1stRun === '100.00' ? 100 + '%' : items.successOf1stRun + '%',
                status: items.status,
            }
            let downloadObj = {
                botId: items.botId,
                totalRuns: items.totalRuns,
                //totalSuccess: items.totalSuccess,
                successOnFirstRun: items.successOnFirstRun === 0 ? '0' : items.successOnFirstRun,
                successOf1stRun: isNaN(items.successOf1stRun) || items.successOf1stRun === '0.00' ? '0' : items.successOf1stRun === '100.00' ? 100 + '%' : items.successOf1stRun + '%',
                status: items.status,
            }
            dataArr.push(dataObj);
            downloadArr.push(downloadObj);
            setBotsCount(count);
        })
        setFirstTimeRunTableData(dataArr);
        setFirstTimeDownloadRows(downloadArr);
    }

    function prepareFirstTimeRunTable(resp) {
        let tableObj = {}, tableData = [];
        let botIdBuckets = resp.aggregations.BOT_ID.buckets;
        console.log(botIdBuckets);
        botIdBuckets.map((botItem) => {
            console.group(botItem);
            let automataBuckets = botItem['Automata_Status'].buckets;
            automataBuckets.map((automataStatus) => {
                let FirstRunSuccessPercent = (automataStatus.First_Time_Sucessful_Run.value / automataStatus.Total_Runs.value) * 100
                tableObj = {
                    botId: botItem.key,
                    totalRuns: botItem.Total_Runs.value,
                    //totalSuccess: automataStatus.Total_Sucessful.value,
                    successOnFirstRun: automataStatus.First_Time_Sucessful_Run.value,
                    successOf1stRun: FirstRunSuccessPercent.toFixed(2),
                    status: automataStatus.key
                }
                tableData.push(tableObj);
            });
        });

        prepareTableBarData(tableData);
    }

    function prepareFirstTimeRunBarData(data) {
        let barDataArr = [];
        barDataArr = [
            {
                "group": "0%-25%",
                "value": data.range1
            },
            {
                "group": "25%-50%",
                "value": data.range2
            },
            {
                "group": "50%-80%",
                "value": data.range3
            },
            {
                "group": "80%-95%",
                "value": data.range4
            },
            {
                "group": "95%-99.9%",
                "value": data.range5
            },
            {
                "group": "Full 100%",
                "value": data.range6
            },
            {
                "group": "0",
                "value": data.range7
            }
        ]
        setFirstTimeBarData(barDataArr);
    }

    const lineGraphHeaders = [{ key: 'group', header: DashboardConstants.Group }, { key: 'date', header: DashboardConstants.Date },
    { key: 'value', header: DashboardConstants.Value }];

    const colors = {
        '0%-25%': "#FA6400",
        '25%-50%': "#F7B500",
        '50%-80%': "#0091FF",
        '80%-95%': "#32C5FF",
        '95%-99.9%': "#44D7B6",
        'Full 100%': "#6DD400",
        '0': "#E02020",
    };

    const options = {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels"
            }
        },
        "height": "400px",
        "modalTitle": "",
        //"legend": true,
        color: {
            scale: colors
        },
    }

    return (
        <div className="top-margin dashboard Bot-performance">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-charts-container">
                    <div className="report-title dashboard">
                        <div className="carbon-display-Semibold-16">{DashboardConstants.BotPerformance}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div style={{ display: "flex" }}>
                                <div>{DashboardConstants.RobotTerminationTrend}</div>
                                <Tooltip direction="right">
                                    <div style={{ color: "black", fontSize: "14px" }}>
                                        {DashboardConstants.LineChartTooltip}
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={BotPerformanceGraphData} headers={lineGraphHeaders} title={DashboardConstants.RobotTerminationTrend} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="line-chart">
                            <DashboardLineChart lineGraphData={BotPerformanceGraphData} loading={BotPerformanceGraphLoading} graphTitle={DashboardConstants.TerminationsPercent} modalTitle="" />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.RobotPerformanceSummary}</div>
                        </div>
                        <div>
                            {paginatedRows.map((tabledata) => (
                                <section className="report-container">
                                    <div className="bold-border-table nested-table">
                                        <div className="report-title bot-table" style={{ color: '#000000' }}>
                                            <div className="carbon-display-Semibold-16 bot-tablename"> {tabledata.tablename}</div>
                                            <div className="download-button">
                                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={tabledata.data} headers={BOTTable.BotPerformanceTableHeaders} title={`Bot Performance ${tabledata.tablename}`} filename={DashboardConstants.BotPerformanceFileName} label={DashboardConstants.Download} />
                                            </div>
                                        </div>
                                        <DashboardTable loading={BotPerformanceLoading} rows={tabledata.data} headers={BOTTable.BotPerformanceTableHeaders} showPagination={true} isSortingAllowed={false} />
                                    </div>
                                </section>
                            ))}
                            {BotPerformanceTableData.length ?
                                <Pagination totalItems={BotPerformanceTableData.length} backwardText={DashboardConstants.PreviousPage} forwardText={DashboardConstants.NextPage}
                                    pageSize={3} pageSizes={[3, 6, 9, 12]} itemsPerPageText={DashboardConstants.Itemspage} style={{ border: '1px solid #E0E0E0' }}
                                    onChange={({ page, pageSize }) => { let newFirstRowIndex = pageSize * (page - 1); setFirstRowIndex(newFirstRowIndex); getPaginatedRows(newFirstRowIndex, pageSize); }} /> : ''}
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div className='title'>{DashboardConstants.FirstTimeRun}</div>
                            {firstTimeBarData.length > 0 && firstTimeRunTableData.length > 0 ?
                                <div className="download-button" style={{ marginRight: '20px' }}>
                                    <TableToolbarDownload iconDescription='Export' rows={firstTimeRunTableData.length === 0 ? [] : firstTimeDownloadRows} headers={BOTTable.firstTimetableHeaders} title={DashboardConstants.FirstTimeRun} filename={DashboardConstants.FirstTimeRun} label={DashboardConstants.Download} />
                                </div> : null}
                        </div>
                        <div className="tile-view">
                            <div className="report-container simpleBar-chart  col-lg-4">
                                {firstTimeBarData.length > 0 && firstTimeRunTableData.length > 0 ?
                                    <SimpleBarChart
                                        loading={barChartLoading}
                                        data={firstTimeBarData}
                                        options={options}>
                                    </SimpleBarChart>
                                    : <div style={{ marginLeft: '20px' }}>{DashboardConstants.NoDataAvailable}</div>
                                }
                            </div>
                            <div className="bold-border-table nested-table col-lg-8">
                                <TableComponent rows={firstTimeRunTableData} headers={BOTTable.firstTimetableHeaders} loading={firstTimeTableLoading} botsCount={botsCount} />
                            </div>
                        </div>
                    </section>
                </div>
            </div >
        </div >
    );
};

export default BotPerformance;
